import React, {Component} from 'react'
import CircleShape from "../types/CircleShape";
import RenderText from "../render-text";
import {GradientDefs, GradientFillUrl} from "shape-edit/forms/fields";
import {textOverflowResizeLayer} from "app/helpers/other";
import { Size } from 'app/types/model-types';
import { EditModeType } from 'app/types/app-types';

interface Props {
    data: CircleShape
    activeShapeId: string
    updateShape: Function
    editMode: EditModeType
}

interface State {
    newSize: Size
}

class CircleSvg extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            newSize: null,
        }
    }

    setRealSize = (newSize: Size) => {
        this.setState({newSize: newSize})
    }

    render() {
        const shapeObject : CircleShape = this.props.data
        const scale = shapeObject.scale && shapeObject.scale !== 0 ? shapeObject.scale : 1

        const isShadow = shapeObject.shadow_color && shapeObject.shadow_sigma

        const newSize =  textOverflowResizeLayer(shapeObject)
        const width = newSize.width || shapeObject.width
        const height = newSize.height || shapeObject.height

        const h = Math.round(shapeObject.text_fontsize / scale)

        return (
            <g className="draggable">
                {isShadow &&
                <filter id={`shadow-${shapeObject.index}`} width="200%" height="200%" y="-50%" x="-50%">
                    <feDropShadow
                        dx={shapeObject.shadow_xoffset}
                        dy={shapeObject.shadow_yoffset}
                        stdDeviation={shapeObject.shadow_sigma}
                        floodColor={shapeObject.shadow_color}
                        floodOpacity={1-shapeObject.shadow_opacity/100}
                    />
                </filter>
                }

                {shapeObject.gradient_id && shapeObject.gradient &&
                <GradientDefs gradient={shapeObject.gradient} idx={shapeObject.gradient_id} />
                }

                <ellipse
                    rx={width/2}
                    ry={height ? height/2 : width/2}
                    fill={shapeObject.gradient_id && shapeObject.gradient ? GradientFillUrl(shapeObject.gradient_id) : shapeObject.color}
                    fillOpacity={shapeObject.gradient_id && shapeObject.gradient && shapeObject.gradient.opacity ? shapeObject.gradient.opacity / 100 : 1}
                    strokeWidth={shapeObject.stroke_width}
                    stroke={shapeObject.stroke_color}
                    filter={isShadow ? `url(#shadow-${shapeObject.index})` : ''}
                />

                <RenderText
                    shape={shapeObject}
                    fontSize={h}
                    width={width}
                    h={height}
                    setRealSize={this.setRealSize}
                    offsetY={0}
                    activeShapeId={this.props.activeShapeId}
                    updateShape={this.props.updateShape}
                    editMode={this.props.editMode}
                />
            </g>
        )
    }
}

export default CircleSvg
